module.exports = __webpack_public_path__ + "static/media/check.c01a781d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/check.svg
// module id = 531
// module chunks = 0